import { Button, Card, Col, Row, Typography } from "antd";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { pricingFeatures } from "../landingData";

const { Title, Paragraph, Text } = Typography;

export function PricingSection() {
  const navigate = useNavigate();

  return (
    <section id="pricing" className="landing-section landing-pricing">
      <Card className="landing-pricing-card">
        <div className="landing-pricing-badge">
          MOST POPULAR - 95% OF SALONS CHOOSE THIS
        </div>

        <Title level={2}>Professional Plan</Title>

        <div className="landing-price">
          $149<span>/month</span>
        </div>

        <Paragraph>
          One price for the core tools you need to run your shop.
        </Paragraph>

        <Row gutter={[16, 16]}>
          {pricingFeatures.map((feature) => (
            <Col xs={24} md={12} key={feature}>
              <Text>
                <Check size={16} /> {feature}
              </Text>
            </Col>
          ))}
        </Row>

        <Button
          type="primary"
          size="large"
          block
          className="landing-pricing-button"
          onClick={() => navigate("/register")}
        >
          Start Your Free Trial
        </Button>

        <Paragraph className="landing-pricing-subtext">
          No credit card required • Setup in 10 minutes • Cancel anytime
        </Paragraph>

        <div className="landing-pricing-callout">
          <div>
            <Title level={3}>$0</Title>
            <Text>Setup Fee</Text>
          </div>
          <div>
            <Title level={3}>$0</Title>
            <Text>Training Cost</Text>
          </div>
          <div>
            <Title level={3}>$0</Title>
            <Text>Migration Fee</Text>
          </div>
        </div>
      </Card>

      <div className="landing-pricing-enterprise">
        <Text type="secondary">Need multiple locations? Managing 20+ staff?</Text>
        <Button type="link" onClick={() => navigate("/register")}>
          Contact us for Enterprise pricing →
        </Button>
      </div>
    </section>
  );
}
